import { useEffect, useState } from 'react';
import { HiSearch } from 'react-icons/hi';
import MaterialInput from './MaterialInput';

type ImageKeywordInterface = {
  didSelectKeyword?: (keyword: string) => void;
  value?: string;
}

const ImageKeyword = (props: ImageKeywordInterface) => {
  const [keyword, setKeyword] = useState<string>(props.value ?? '');

  useEffect(() => {
    setKeyword(props.value ?? '');
  }, [props.value])

  const search = () => {
    props.didSelectKeyword?.(keyword);
  }
  const handleInputChange = (target: HTMLElement) => {
    const inputText = (target as HTMLInputElement).value;
    setKeyword(inputText);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (!event.nativeEvent.isComposing && event.key === 'Enter') {
      search();
    }
  };

  return (
    <div>
      <MaterialInput
        value={keyword}
        name='keyword'
        placeholder='キーワード'
        didChangePart={handleInputChange}
        onKeyDown={(event) => handleKeyDown(event)}
        symbol={<HiSearch />}
        didClickSymbol={search}
      />
    </div>
  );
}

export default ImageKeyword;
